import { Grid, IconButton, Tooltip } from "@material-ui/core";
import { Fragment, useEffect } from "react";
// import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import AddRoundedIcon from "@material-ui/icons/AddRounded";
import DeleteIcon from "@material-ui/icons/Delete";
import DetalleAnuncio from "./DetalleAnuncio";
import EliminarAnuncio from "./EliminarAnuncio";
import EditIcon from "@material-ui/icons/Edit";
import FormAnuncio from "./FormAnuncio";
// import MeditocActions from "../../../utils/MeditocActions";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocHeader from "../../../utils/MeditocHeader";
import MeditocTable from "../../../utils/MeditocTable";
import RefreshIcon from "@material-ui/icons/Refresh";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { fnEmpty } from "../../../../settings/preventConfig";
import { getAnunciosColumns } from "../../../../models/AnuncioModel";
import { useAnuncio } from "../../../../context/AnuncioContext";
import { useLogin } from "../../../../context/LoginContext";

export default function Anuncio() {
    const {
        listaAnuncios,
        anuncioSeleccionado,
        handleChangeAnuncioSeleccionado,
        handleClickNuevoAnuncio,
        handleClickEditarAnuncio,
        handleClickDetalleAnuncio,
        handleClickEliminarAnuncio,
        handleClickRefrescarDatos,
    } = useAnuncio();
    const { usuarioPermisos } = useLogin();

    const permisos = usuarioPermisos["2"].Submodulos["6"];

    useEffect(() => {
        handleClickRefrescarDatos();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] && ( //Crear un anuncio
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <IconButton onClick={handleClickNuevoAnuncio}>
                            <AddRoundedIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["5"] && ( //Editar un anuncio
                    <Tooltip title={permisos.Botones["5"].Nombre} arrow>
                        <IconButton onClick={handleClickEditarAnuncio}>
                            <EditIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["2"] && ( //Detalle de anuncio
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <IconButton onClick={handleClickDetalleAnuncio}>
                            <VisibilityIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["3"] && ( //Eliminar anuncio
                    <Tooltip title={permisos.Botones["3"].Nombre} arrow>
                        <IconButton onClick={handleClickEliminarAnuncio}>
                            <DeleteIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["4"] && ( //Actualizar tabla
                    <Tooltip title={permisos.Botones["4"].Nombre} arrow>
                        <IconButton onClick={handleClickRefrescarDatos}>
                            <RefreshIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocHeader>
            <MeditocBody>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <MeditocTable
                            id="iIdAnuncio"
                            data={listaAnuncios}
                            row={anuncioSeleccionado}
                            columns={getAnunciosColumns()}
                            setRow={handleChangeAnuncioSeleccionado}
                            fnDoubleClick={permisos.Botones["2"] ? handleClickDetalleAnuncio : fnEmpty}
                        />
                    </Grid>
                </Grid>
            </MeditocBody>
            <FormAnuncio />
            <DetalleAnuncio />
            <EliminarAnuncio />
        </Fragment>
    );
}
